import { ResultsPane } from "./ResultsPane";
export default ResultsPane;
